import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    maxWidth: 250,
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'tomato',
    background: '#222',
  },
});
